import { Head } from "@inertiajs/inertia-react";

export default ({ title, children }) => {
    return (
        <Head>
            <title>{title ? `${title} - Motherland` : `Motherland`}</title>
            {children}
        </Head>
    );
};
